import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const SomethingWentWrong = ({dispatch}) => {

    useEffect(() => {
        function clearCookiesAndLocalStorage() {
            // Clear all cookies
            const cookies = document.cookie.split(";");
          
            for (let i = 0; i < cookies.length; i++) {
              const cookie = cookies[i];
              const eqPos = cookie.indexOf("=");
              const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
            }
          
            // Clear localStorage
            localStorage.clear();
            dispatch({ event: "Login" })
          }
          
          // Example of usage
          clearCookiesAndLocalStorage();
          
    }, [])
    

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      textAlign="center"
    >
      <ErrorOutlineIcon style={{ fontSize: 80, color: '#d32f2f', marginBottom: '20px' }} />
      <Typography variant="h4" gutterBottom>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1" gutterBottom>
        We're sorry, but an unexpected error occurred.
      </Typography>
    </Box>
  );
};

export default SomethingWentWrong;
